import React , {Component} from 'react';



export default class TermsConditionPage extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div className='privacy-policy-main'>
            <div className='container-fluid'>
            <div className='privacy-policy-head'>
            <h3>Terms & Conditions</h3>
            </div>
            </div>
            
            </div>
        )
    }
}

